import styled, { css } from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

export const Container = styled.label<{ disabled: boolean }>`
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-bottom: 18px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

export const RadioStyled = styled.input<{ ref?: any }>`
  display: inline-block;
  width: 18px;
  height: 18px;
  background-clip: content-box;
  border: 1px solid ${theme.colors.primary.black};
  border-radius: 50%;
  background-color: ${theme.colors.primary.transparentBg};
  margin-right: 8px;

  &:checked {
    background-color: ${theme.colors.primary.bariBlue};
    padding: 2px;
    border: 3px solid ${theme.colors.primary.bariBlue};
    background-size: 12px;
  }

  &:focus {
    outline: none !important;
  }
`;

export const Span = styled.span`
  font-size: 14px;
`;
